import { msg } from '@gonfalon/messages/msg';
import { capitalize } from '@gonfalon/strings/capitalize';

import { getExperimentApprovalAction } from './getExperimentApprovalAction';
import type { ApprovalRequest } from './records/ApprovalRequest';

export const getApprovalAppliedNotificationMessage = (updatedApproval: ApprovalRequest) => {
  const readableResourceKind = capitalize(updatedApproval.getReadableResourceKindName());

  if (updatedApproval.status === 'failed') {
    return msg('approvals.notification.updateFailed', { resourceKind: readableResourceKind });
  }
  if (updatedApproval.instructions.isEmpty()) {
    return msg('approvals.notification.scheduledChangesDeleted');
  }
  if (updatedApproval.executionDate) {
    return msg('approvals.notification.changesScheduled');
  }
  const experimentAction = getExperimentApprovalAction(updatedApproval);
  if (experimentAction) {
    return msg('approvals.notification.experimentAction', { action: experimentAction });
  }
  return msg('approvals.notification.changesApplied', { resourceKind: readableResourceKind });
};
